module.exports = __webpack_public_path__ + "img/3_pc.1acdbe8b.gif";